(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veluna-product"] && !Shopify.designMode) return;
  try {
    
  function initializeVelunaProduct(scope) {
    scope.querySelectorAll('[data-veluna-product]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const stickyBuy = section.querySelector('[data-sticky-buy]');
      const buyArea = section.querySelector('.vp-buy');
      if (stickyBuy && buyArea) {
        let queued = false;
        const updateSticky = () => { stickyBuy.hidden = buyArea.getBoundingClientRect().bottom >= 0; queued = false; };
        const queueSticky = () => { if (!queued) { queued = true; requestAnimationFrame(updateSticky); } };
        addEventListener('scroll', queueSticky, {passive:true});
        addEventListener('resize', queueSticky);
        if ('IntersectionObserver' in window) new IntersectionObserver(queueSticky).observe(buyArea);
        updateSticky();
      }
      const track = section.querySelector('[data-gallery-track]');
      const thumbs = [...section.querySelectorAll('[data-gallery-thumb]')];
      let active = 0;
      const goTo = index => { active = Math.max(0, Math.min(thumbs.length - 1, index)); track.scrollTo({left: track.clientWidth * active, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}); };
      thumbs.forEach((button, index) => button.addEventListener('click', () => goTo(index)));
      section.querySelector('[data-gallery-prev]').addEventListener('click', () => goTo(active - 1));
      section.querySelector('[data-gallery-next]').addEventListener('click', () => goTo(active + 1));
      let frame;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          active = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach((button, index) => {
            button.classList.toggle('is-active', index === active);
            if (index === active) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current');
          });
        });
      }, {passive:true});
      const tabs = [...section.querySelectorAll('[data-tab]')];
      const panels = [...section.querySelectorAll('[data-tab-panel]')];
      const activateTab = index => {
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index; });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(index));
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;
          if (target !== undefined) { event.preventDefault(); activateTab(target); tabs[target].focus(); }
        });
      });
      activateTab(0);
      section.querySelectorAll('[data-quantity-change]').forEach(button => button.addEventListener('click', () => {
        const input = section.querySelector('input[name="quantity"]');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(button.dataset.quantityChange));
        input.dispatchEvent(new Event('change', {bubbles:true}));
      }));
      const variantSelect = section.querySelector('[data-variant-select]');
      variantSelect?.addEventListener('change', () => {
        const selected = variantSelect.selectedOptions[0];
        section.querySelector('[data-variant-price]').textContent = selected.dataset.price;
        const compare = section.querySelector('[data-variant-compare]');
        compare.textContent = selected.dataset.compare;
        compare.hidden = !selected.dataset.compare;
        const add = section.querySelector('[data-add-to-cart]');
        add.disabled = selected.dataset.available !== 'true';
        add.textContent = add.disabled ? add.dataset.soldText : add.dataset.addText;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeVelunaProduct(document)); else initializeVelunaProduct(document);
  document.addEventListener('shopify:section:load', event => initializeVelunaProduct(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veluna-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('veluna-reviews-carousel')) {
  customElements.define('veluna-reviews-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('[data-track]');
      const controls = this.querySelector('[data-controls]');
      if (!track || !controls) return;
      const previous = controls.querySelector('[data-prev]');
      const next = controls.querySelector('[data-next]');
      const cards = Array.from(track.children);
      const update = () => {
        controls.hidden = track.scrollWidth <= track.clientWidth + 4;
        previous.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      };
      const move = direction => {
        const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
        track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veluna-ugc"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('veluna-ugc-carousel')) {
  customElements.define('veluna-ugc-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('[data-track]');
      const controls = this.querySelector('[data-controls]');
      if (!track || !controls) return;
      const previous = controls.querySelector('[data-prev]');
      const next = controls.querySelector('[data-next]');
      const position = controls.querySelector('[data-position]');
      const cards = Array.from(track.children);
      const update = () => {
        const hasOverflow = track.scrollWidth > track.clientWidth + 4;
        controls.hidden = !hasOverflow;
        previous.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
        const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
        position.textContent = `${Math.min(cards.length, Math.round(track.scrollLeft / step) + 1)} / ${cards.length}`;
      };
      const move = direction => {
        const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
        track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
